import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import {
    setErrorPopDoorKey, setToRescan,
    setDoorKeyNotificaionPage,
    setDoorKeyValidationPopUp, setQRScannerPage
} from '../../action/action'
import { popupColorSet } from '../../JS/setColors'
import { withTranslation } from 'react-i18next';

class DoorErrorPopup extends Component {
    onNoClick = () => {
        this.props.setErrorPopDoorKey(false);
        this.props.setDoorKeyNotificaionPage(false);
        this.props.setDoorKeyValidationPopUp(false);
        this.props.setQRScannerPage(false);
        if (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)
            document.location.reload();
    }

    componentDidMount() {
        popupColorSet(this.props.menuColor);
    }

    startRescan = () => {
        this.props.setErrorPopDoorKey(false);
        this.props.setToRescan(true);
    }

    render() {
        const {t} = this.props
        return (
            <div class="overlay">
                <div id="svc" className="overlay-body">
                    <div className="overlay-close" onClick={this.onNoClick}>
                        <i class="fa fa-close" style={{ color: "inherit" }}></i>
                    </div>
                    <div className="response" style={{ color: "inherit" }}>
                        {t('door_key.invalid_qr')}
                    </div>
                    <button onClick={this.startRescan} style={{ margin: "5px", marginLeft: "35%" }}>{t('door_key.scan_again')}</button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        notInHotelPopup: state.store.notInHotelPopup,
        popupMsg: state.store.popupMsg,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
    }
}

export default connect(
    mapStateToProps,
    {
        setErrorPopDoorKey,
        setToRescan,
        setDoorKeyNotificaionPage,
        setDoorKeyValidationPopUp,
        setQRScannerPage
    }
)(withTranslation('translations')(DoorErrorPopup));